// PastWorkCard.js
import React from 'react';
import { Card, CardContent, Typography, Grid } from '@mui/material';

const PastWorkCard = ({ work }) => {
  return (
    <Grid item xs={12} sm={6} md={4}>
      <Card>
        <CardContent>
          <Typography variant="h6" component="div" gutterBottom>
            {work.title}
          </Typography>
          <div style={{ position: 'relative', paddingTop: '56.25%' }}>
            <iframe
              src={work.videoUrl}
              title={work.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
              }}
            ></iframe>
          </div>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default PastWorkCard;
